export default "__VITE_ASSET__DuBbGcNl__"